export default {
  namespaced: true,

  state: {
    isFetching: false,
    items: {}
  },

  mutations: {
    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    },
    SET_RESUMO_PROJETO(state, payload) {
      state.items[payload.projetoId] = payload.resumo
    },

  },

  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    calcularResumo: ({ dispatch, commit, getters, rootGetters }, projetoId) => {
      dispatch, commit, getters, rootGetters
      dispatch('requestOn');
      console.log('Request On Resumindo projeto')

      return Promise.resolve().then(() => {

        const intervencoes = rootGetters["logicaIntervencao/byProjeto"](projetoId)
        
        intervencoes.forEach((entry) => {
          let indicadores = rootGetters["indicador/byLogicaIntervencaoId"](entry.id)
          let resumoIndicador = {}
          let progressoLogicaIntervencao = 0.00
          resumoIndicador['progressoIndicadores'] = 0.00
          resumoIndicador['numeroDeIndicadores'] = indicadores.length
          resumoIndicador['indicadoresConcluidos'] = indicadores.filter(item => item.porcentagemTotalAtingido >= 100).length
          
          if (resumoIndicador.numeroDeIndicadores) {
            let sum = parseFloat(indicadores.reduce((accumulator, object) => { return accumulator + object.porcentagemTotalAtingido;}, 0.00))
            resumoIndicador['progressoIndicadores'] = parseFloat(parseFloat(sum / resumoIndicador.numeroDeIndicadores).toFixed(2))
            progressoLogicaIntervencao = resumoIndicador.progressoIndicadores
          }

          const payload = { 'logicaIntervencaoId': entry.id, 'resumoIndicador': resumoIndicador }

          const payloadProgresso = { 'logicaIntervencaoId': entry.id, 'progressoLogicaIntervencao': progressoLogicaIntervencao }

          //commit('logicaIntervencao/SET_PROGRESSO_LOGICA_INTERVENCAO', payloadProgresso, { root: true })
          commit('SET_PROGRESSO_LOGICA_INTERVENCAO', payloadProgresso, { root: true })

          //commit('logicaIntervencao/SET_RESUMO_INDICADOR', payload, { root: true })
          commit('SET_RESUMO_INDICADOR', payload, { root: true })
        });
                
        const produtos = rootGetters["logicaIntervencao/produtosByProjeto"](projetoId)
        produtos.forEach((produto) => {
          let progressoLogicaIntervencao = 0.00
          let resumoAtividade = {}
          resumoAtividade['progressoAtividades'] = 0.00
          resumoAtividade['numeroDeAtividades'] = produto.atividades.length
          resumoAtividade['atividadesConcluidas'] = produto.atividades.filter(item => item.resumoIndicador.progressoIndicadores >= 100).length


          if (resumoAtividade.numeroDeAtividades) {
            let sum = parseFloat(produto.atividades.reduce((accumulator, object) => { return accumulator + object.resumoIndicador.progressoIndicadores;}, 0.00))
            resumoAtividade['progressoAtividades'] = parseFloat(parseFloat(sum / resumoAtividade.numeroDeAtividades).toFixed(2))
            progressoLogicaIntervencao = parseFloat(parseFloat(parseFloat(resumoAtividade.progressoAtividades + produto.resumoIndicador.progressoIndicadores) / 2).toFixed(2))
          }

          const payload = { 'logicaIntervencaoId': produto.id, 'resumoAtividade': resumoAtividade }
          //commit('logicaIntervencao/SET_RESUMO_ATIVIDADE', payload, { root: true })
          commit('SET_RESUMO_ATIVIDADE', payload, { root: true })

          const payloadProgresso = { 'logicaIntervencaoId': produto.id, 'progressoLogicaIntervencao': progressoLogicaIntervencao }
          //commit('logicaIntervencao/SET_PROGRESSO_LOGICA_INTERVENCAO', payloadProgresso, { root: true })
          commit('SET_PROGRESSO_LOGICA_INTERVENCAO', payloadProgresso, { root: true })
        });

        console.log('Request Off Resumindo projeto')
        dispatch('requestOff');
  


      })



    },


  },

  getters: {    
    isFetching: (state) => {
      return state.isFetching
    },

    someGetter (state, getters, rootState, rootGetters) {
      state.items
      getters.someOtherGetter // -> 'foo/someOtherGetter'
      rootGetters.someOtherGetter // -> 'someOtherGetter'
      rootGetters['bar/someOtherGetter'] // -> 'bar/someOtherGetter'      
    },    

    intervencoesbyProjeto: (state, getters, rootState, rootGetters) => projetoId => {
      state, getters, rootState, rootGetters
      return rootGetters["logicaIntervencao/byProjeto"](projetoId);
    },
    
    nivelProdutoByProjeto: (state, getters, rootState, rootGetters) => projetoId => {
      state, getters, rootState, rootGetters
      return rootGetters["logicaIntervencao/byProjeto"](projetoId);      
    },



    

    byProjeto: (state) => projetoId => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao => logicaIntervencao.projeto.id === projetoId)
          .sort((a, b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0));
      }
      return []
    },

    atividadesByProjeto: (state) => projetoId => {
      if (state.items) {
        return Object.values(state.items)
          .filter(logicaIntervencao => logicaIntervencao.projeto.id === projetoId && logicaIntervencao.nivel === "OBJETIVO_GERAL")
          .sort((a, b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0));
      }
      return []
    },

 },
}